import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuItem, NbMenuService, NbSidebarService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { ActionState, AssistantConfig, BaseComponentConfig, ComponentConfig, CustomContainerItem, Relation, SelectedValue, UbsComponentStoreService, UpdateComponentStoreService, ViewContainersService } from '@urbannex/view-containers';
import { options } from '../configoptions';

@Component({
  selector: 'ubs-product',
  template: `<ng-container *ngIf="hasValue">
    <ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>
  </ng-container>`,
  styleUrls: ['./product.component.scss']
})
export class ProductComponent extends BaseComponentConfig implements OnInit {
  productId: string;
  selectedValue: SelectedValue;
  hasValue = false;
  @Output() contextMenuItems = new EventEmitter<NbMenuItem[]>()
  @Output() assistantConfig = new EventEmitter<AssistantConfig>()

  constructor(viewContainerService: ViewContainersService,
    menuService: NbMenuService,
    route: ActivatedRoute,
    router: Router,
    updateComponentStoreService: UpdateComponentStoreService,
    configurationService: ConfigurationService,
    private componentStore: UbsComponentStoreService) {
    super(viewContainerService, menuService, configurationService, route, router, updateComponentStoreService)

    this.route.paramMap.subscribe((params) => {
      if (params.get("productId")) {
        this.productId = params.get("productId");
        if (this.productId != undefined) {
          this.route.data.subscribe(data => {
            console.log(data);
            if (data.event) {
              this.action = data.event;
              this.routerData = data;
            }
          })
          this.createMenuItems(this.productId);
          this.setSelectedValue(this.productId)
        }
      }
    })
    /* this.sidebarService.getSidebarState('right').subscribe((state) => {
      console.log("Sidebar state",state);
    }); */
  }

  ngOnInit(): void {
    console.log("Fokit man okay");
    if (this.productId != undefined) {
      if (this.action != null && this.action != undefined) {
        const paths = this.getPaths(options, this.action);
        let path;
        paths.forEach((p) => {
          if (this.router.url.includes(p)) {
            path = p;
          }
        })
        switch (this.action) {
          case ActionState.RELATE:
            const selectedRelation: Relation = this.setSelectedValueView(this.action, path, options);
            selectedRelation.listForm.findParameters = [];
            selectedRelation.listForm.findParameters.push({ "productId": this.productId })
            break;
          case ActionState.MASTERDETAIL:
            options.selectedMasterDetails = this.setSelectedValueView(this.action, path, options);
            break;
          case ActionState.TASKSACTRSLT:
            options.selectedTask = this.setSelectedValueView(this.action, path, options);
            break;
          default:
            break;
        }
        /* if(this.action == ActionState.MASTERDETAIL || this.action == ActionState.RELATE){
          if(this.action == ActionState.MASTERDETAIL){
            options.selectedMasterDetails = this.setSelectedRelation(this.action,this.selectedValueType);
          }
          if(this.action == ActionState.RELATE){
            options.selectedRelation = this.setSelectedRelation(this.action,this.selectedValueType);
          }
          this.setListOption(this.action);
        }else if(this.action == ActionState.TASKSACTRSLT) {
          options.selectedTask = this.setSelectedTask (this.selectedValueType);
        } */
      }
    } else {
      console.log("No productId");
      this.action = ActionState.ADD;
      /* this.componentStore.updateSelectedValue({
        event:ActionState.ADD,
        type:"EditProductRest",
        label:"Edit Product",
        data:{
          formData: {
            formName: 'EditProductRest',
            formLocation: 'component://kwikstore/widget/ProductForms.xml',
          },
        }
      }); */

      options.defaultAction = this.action ? this.action : ActionState.EDIT;
      // options.addForm.breadCrumbData.selectedValue = selectedValue;
      this.componentConfig = new ComponentConfig(options);
      console.log(this.componentConfig)
      this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
      this.hasValue = true;
      /**
       * Check if there is an assistantConfig form the component
       */
      if (this.componentConfig.assistant) {
        this.assistantConfig.emit(this.componentConfig.assistant)
      }
    }
  }

  setSelectedValueType(action: ActionState): string {
    // let url: string;
    let selectedValueType;
    switch (action) {
      case ActionState.CUSTOM:
        if (this.router.url.includes('facility-overview')) {
          selectedValueType = "FacilityOverView";
          // options.customContainerItems = [new CustomContainerItem("FacilityOverView", FacilityOverviewComponent, {facilityId:this.facilityId})]
        }
        break;
      case ActionState.MASTERDETAIL:
        if (this.router.url.includes('facility-locations')) {
          selectedValueType = "Facility Locations";
        }
        if (this.router.url.includes('orders')) {
          selectedValueType = "Orders";
        }
        break;
      case ActionState.RELATE:
        if (this.router.url.includes('prices')) {
          selectedValueType = "Prices";
        } else if (this.router.url.includes('categories')) {
          selectedValueType = "Categories";
        } else if (this.router.url.includes('features')) {
          selectedValueType = "Features";
        } else if (this.router.url.includes('keywords')) {
          selectedValueType = "Keywords";
        } else if (this.router.url.includes('associations')) {
          selectedValueType = "Associations";
        } else if (this.router.url.includes('attributes')) {
          selectedValueType = "Attributes";
        } else if (this.router.url.includes('ids')) {
          selectedValueType = "Identifications";
        } else if (this.router.url.includes('locations')) {
          selectedValueType = "Locations";
        } else if (this.router.url.includes('geos')) {
          selectedValueType = "Geos";
        } else if (this.router.url.includes('meters')) {
          selectedValueType = "Meters";
        } else if (this.router.url.includes('suppliers')) {
          selectedValueType = "Suppliers";
        } else if (this.router.url.includes('costs')) {
          selectedValueType = "Costs";
        } else if (this.router.url.includes('agreements')) {
          selectedValueType = "Agreements";
        } else if (this.router.url.includes('vendor')) {
          selectedValueType = "Vendor";
        } else if (this.router.url.includes('accounts')) {
          selectedValueType = "Accounts";
        } else if (this.router.url.includes('groupOrder')) {
          selectedValueType = "Group Order";
        } else if (this.router.url.includes('facilities')) {
          selectedValueType = "Facilities";
        } else if (this.router.url.includes('inventory')) {
          selectedValueType = "Inventory";
        } else if (this.router.url.includes('maintenance')) {
          selectedValueType = "Maintenance";
        } else if (this.router.url.includes('content')) {
          selectedValueType = "Content";
        } else if (this.router.url.includes('subscriptions')) {
          selectedValueType = "Subscription Resources";
        } else if (this.router.url.includes('work-eEfforts')) {
          selectedValueType = "WorkEfforts";
        } else if (this.router.url.includes('parties')) {
          selectedValueType = "Parties";
        } else if (this.router.url.includes('orders')) {
          selectedValueType = "Orders";
        } else if (this.router.url.includes('communications')) {
          selectedValueType = "Communications";
        } else if (this.router.url.includes('payment-types')) {
          selectedValueType = "Payment Types";
        } else if (this.router.url.includes('subscription-resources')) {
          selectedValueType = "Subscription Resources";
        }
        break;
      case ActionState.TASKSACTRSLT:
        if (this.router.url.includes('receive-inventory-order')) {
          selectedValueType = "Receive Inventory By Purchase Order"
        } else if (this.router.url.includes('receive-inventory-product')) {
          selectedValueType = "Receive Inventory By Product"
        }
        break
      default:
        break;
    }

    return selectedValueType;
  }

  setSelectedValue(productId: string) {
    options.defaultAction = this.action ? this.action : ActionState.EDIT;

    if (this.action == ActionState.RELATE) {
      const relations: any[] = options.relations;
      console.log(relations);
      let position: number;
      relations.forEach((relation: Relation, i) => {
        if (relation.title == this.routerData["type"]) {
          this.selectedRelation = relation;
          position = i;
          console.log(this.selectedRelation, i)
        }
      })
      if (this.selectedRelation != undefined) {
        // Move the selected relation to the top
        const reorderedRelations = this.reOrderRelations(relations, position);
        console.log(reorderedRelations);
        options.relations = reorderedRelations;
      }
    }
    const selectedValue: SelectedValue = {
      event: ActionState.EDIT,
      type: "EditProductRest",
      label: "Edit Product",
      data: {
        formData: {
          formName: 'EditProductRest',
          formLocation: 'component://kwikstore/widget/ProductForms.xml',
        },
        parameters: { "productId": productId }
      }

    }
    setTimeout(() => {
      console.log(selectedValue, this.action)
      if (this.action != null && this.action != undefined) {
        if (this.action != ActionState.RELATE && this.action != ActionState.MASTERDETAIL && this.action != ActionState.TASKSACTRSLT && this.action != ActionState.CUSTOM) {
          this.componentStore.updateSelectedValue({
            event: ActionState.EDIT,
            type: "EditProductRest",
            label: "Edit Product",
            data: {
              formData: {
                formName: 'EditProductRest',
                formLocation: 'component://kwikstore/widget/ProductForms.xml',
              },
              parameters: { "productId": productId }
            }
          });
        }
      }
      options.defaultAction = this.action ? this.action : ActionState.EDIT;
      options.addForm.breadCrumbData.selectedValue = selectedValue;
      this.componentConfig = new ComponentConfig(options);
      this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
      this.hasValue = true;
    }, 500)
  }

  createMenuItems(productId: string) {
    const menuItems: NbMenuItem[] = [
      {
        title: "Product [" + productId + "]",
        group: true,
      },
      {
        title: "Product Classification",
        children: [
          {
            "title": "Categories",
            "link": '/admin/products/product/' + productId + '/categories/relate'
          },
          {
            "title": "Features",
            "link": '/admin/products/product/' + productId + '/features/relate'
          },
          {
            "title": "Keywords",
            "link": '/admin/products/product/' + productId + '/keywords/relate'
          },
          {
            "title": "Associations",
            "link": '/admin/products/product/' + productId + '/associations/relate'
          },
          {
            "title": "Attributes",
            "link": '/admin/products/product/' + productId + '/attributes/relate'
          },
          {
            "title": "Identifications",
            "link": '/admin/products/product/' + productId + '/ids/relate'
          },
          {
            "title": "Locations",
            "link": '/admin/products/product/' + productId + '/locations/relate'
          },
          {
            "title": "Geos",
            "link": '/admin/products/product/' + productId + '/geos/relate'
          },
          {
            "title": "Meters",
            "link": '/admin/products/product/' + productId + '/meters/relate'
          }
        ]
      },
      {
        title: "Product Acquisition",
        children: [
          {
            "title": "Suppliers",
            "link": '/admin/products/product/' + productId + '/suppliers'
          },
          {
            "title": "Costs",
            "link": '/admin/products/product/' + productId + '/costs'
          },
          {
            "title": "Agreements",
            "link": '/admin/products/product/' + productId + '/agreements'
          },
          {
            "title": "Vendor",
            "link": '/admin/products/product/' + productId + '/vendor'
          }
        ]
      },
      {
        title: "Financials",
        children: [
          {
            "title": "Prices",
            "link": '/admin/products/product/' + productId + '/prices/relate'
          },
          {
            "title": "Orders",
            "link": '/admin/products/product/' + productId + '/orders/master-detail'
          },
          {
            "title": "Payment Types",
            "link": '/admin/products/product/' + productId + '/payments/relate'
          },
          {
            "title": "Accounts",
            "link": '/admin/products/product/' + productId + '/accounts/relate'
          },
          {
            "title": "Group Order",
            "link": '/admin/products/product/' + productId + '/groupOrder/relate'
          }
        ]
      },
      {
        title: "Logistics",
        children: [
          {
            "title": "Facilities",
            "link": '/admin/products/product/' + productId + '/facilities'
          },
          {
            "title": "Inventory",
            "link": '/admin/products/product/' + productId + '/inventory'
          },
          {
            "title": "Maintenance",
            "link": '/admin/products/product/' + productId + '/maintenance'
          }
        ]
      },
      {
        "title": "Content",
        "link": '/admin/products/product/' + productId + '/content/relate'
      },
      {
        "title": "Subscription Resources",
        "link": '/admin/products/product/' + productId + '/subscriptions/relate'
      },
      {
        "title": "WorkEfforts",
        "link": '/admin/products/product/' + productId + '/workEfforts/relate'
      },
      {
        "title": "Parties",
        "link": '/admin/products/product/' + productId + '/parties/relate',
        data: {
          event: ActionState.RELATE,
          type: "Parties",
          label: "Parties",

        }
      },
      {
        "title": "Communications",
        "link": '/admin/products/product/' + productId + '/communications/relate'
      }
    ]
    console.log("Adding menu items", menuItems)
    // this.menuService.addItems([],'productsMenu');
    // this.viewContainerService.contextMenu$.next(menuItems);
    // this.menuService.addItems(menuItems,'contextMenu');
    setTimeout(() => {
      this.contextMenuItems.emit(menuItems)
    }, 1)

  }


}
